<div class="card" *appIsGranted="['ADMIN', 'ADMIN', 'READ']">
  <div class="card-header">
    <div class="row">
      <div class="col-md-10">
        <h3>Admin</h3>
      </div>
      <div class="col-md-2">
        <button
          class="btn btn-sm btn-primary"
          *appIsGranted="['ADMIN', 'ADMIN', 'CREATE']"
          (click)="emailVerified = false; openModal(modalNewUser)"
        >
          Novo usuário
        </button>
      </div>
    </div>
  </div>
  <div class="card align-items-center" *ngIf="circularProgressiveWait">
    <div card="card-body mt-n3">
      <div class="spinner-border text-primary m-1" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div class="card-body">
    <table class="table table-fit table-bordered table-hover">
      <thead class="table-primary">
        <tr>
          <th scope="col" class="col-md-1 text-center">id</th>
          <th scope="col" class="col-md-3 text-center">Nome<br />Email</th>
          <th scope="col" class="col-md-3 text-center">
            Aeroportos<br />Movida Transfer
          </th>
          <th scope="col" class="col-md-4 text-center" style="max-width: 200px">
            Permissões
          </th>
          <th scope="col" class="col-md-1 text-center">Ação</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let user of users">
          <tr>
            <td scope="row" class="text-center">
              {{ user.id }}
            </td>
            <td scope="row" class="text-center">
              {{ user.name }}<br />
              {{ user.email }}
            </td>
            <td>
              <ng-container *ngIf="user.filterMovidaTransfer">
                <ng-select [(ngModel)]="user.airportsList" [multiple]="true">
                  <ng-option
                    *ngFor="let airport of vanTransferLocal"
                    [value]="airport.id"
                    >{{ airport.name }}</ng-option
                  >
                </ng-select>
              </ng-container>
            </td>
            <td style="max-width: 200px">
              <i
                *appIsGranted="['ADMIN', 'ADMIN', 'CREATE']"
                style="cursor: pointer"
                class="fa fa-edit"
                aria-hidden="true"
                (click)="openModal(modalPermissions, user)"
              ></i>
              <ng-container *ngFor="let perm of user.permissions">
                <ng-container *ngFor="let permItem of perm.items">
                  <ng-container *ngIf="anyValueTrue(permItem)">
                    <div class="badge bg-success">
                      <!-- {{ getDescriptionScreen(perm.screen) ?? "" }} -->
                      {{ getDescriptionItem(perm.screen, permItem.item) }}
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </td>
            <td>
              <!-- <button
                *appIsGranted="['ADMIN', 'UPDATE']"
                type="submit"
                class="btn btn-primary"
                (click)="save(user)"
              >
                Salvar
              </button> -->
              <div class="row">
                <div class="col-md-12">
                  <div class="card mt-1 d-block align-items-center">
                    <div class="text-center">
                      <label style="font-size: xx-small">Filtro Vans</label>
                    </div>
                    <div class="text-center">
                      <input
                        [(ngModel)]="user.filterMovidaTransfer"
                        checked="true"
                        unchecked="false"
                        type="checkbox"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <button
                    *appIsGranted="['ADMIN', 'ADMIN', 'CREATE']"
                    type="button"
                    class="btn btn-primary"
                    (click)="
                      openModalPasswordConfirm(modalPasswordConfirm, user.id)
                    "
                  >
                    Resetar senha
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<ng-template #modalPermissions let-modal>
  <div class="modal-header">
    <h5 class="modal-title mt-0">Permissões</h5>
    <button
      type="button"
      class="btn btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-hidden="true"
    ></button>
  </div>
  <div class="card align-items-center" *ngIf="circularProgressiveWait">
    <div card="card-body mt-n3">
      <div class="spinner-border text-primary m-1" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div class="modal-body" style="height: 500px; overflow: auto">
    <div (submit)="savePermissions()">
      <div *ngFor="let item of permissionsScreen.screens; let i = index">
        <div class="card">
          <div class="m-2" style="border: outset">
            <h5 class="ms-2">{{ item.description }}</h5>
            <div
              style="border: outset"
              *ngFor="let item2 of item.items; let ii = index"
            >
              <div class="ms-2">
                <h6 class="badge bg-success" style="scale: 1.1">
                  {{ getValueObjectByKey(item2, "description") }}
                </h6>
                <div
                  *ngFor="
                    let key of getObjectKeys(
                      getValueObjectByKey(item2, 'names')
                    )
                  "
                >
                  <label>
                    <input
                      type="checkbox"
                      [checked]="
                        getPermissionValue(
                          item.screen,
                          getValueObjectByKey(item2, 'item'),
                          key
                        )
                      "
                      (change)="
                        togglePermission(
                          item.screen,
                          getValueObjectByKey(item2, 'item'),
                          key,
                          getValueObjectByKey(item2, 'id')
                        )
                      "
                    />
                    {{ getValueObjectByKeyAndSubkey(item2, "names", key) }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-success" type="button" (click)="savePermissions()">
      Salvar
    </button>
  </div>
</ng-template>

<ng-template #modalNewUser let-modal>
  <div class="modal-header">
    <h5 class="modal-title mt-0">Novo usuário</h5>
    <button
      type="button"
      class="btn btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-hidden="true"
    ></button>
  </div>
  <div class="card align-items-center" *ngIf="circularProgressiveWait">
    <div card="card-body mt-n3">
      <div class="spinner-border text-primary m-1" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div class="modal-body" style="height: 500px; overflow: auto">
    <form [formGroup]="emailAvaliableForm" (ngSubmit)="emailAvalibleVerify()">
      <div class="row">
        <div class="col-md-10">
          <div class="input-group input-group-sm mb-2">
            <span class="input-group-text">Email</span>
            <input type="text" class="form-control" formControlName="email" />
          </div>
        </div>
        <div class="col-md-2">
          <button
            class="btn btn-sm btn-primary"
            type="submit"
            [disabled]="emailAvaliableForm.invalid"
          >
            Verificar existencia
          </button>
        </div>
      </div>
    </form>
    <ng-container *ngIf="emailVerified">
      <form [formGroup]="newUser.asForm" (ngSubmit)="emailAvalibleVerify()">
        <div class="row">
          <div class="input-group input-group-sm mb-2">
            <span class="input-group-text">Nome</span>
            <input type="text" class="form-control" formControlName="name" />
          </div>
          <div class="input-group input-group-sm mb-2">
            <span class="input-group-text">Username</span>
            <input
              type="text"
              class="form-control"
              formControlName="username"
            />
          </div>
          <button
            class="btn btn-success"
            type="button"
            (click)="createNewUser()"
            [disabled]="emailAvaliableForm.invalid || newUser.asForm.invalid"
          >
            Criar usuário
          </button>
        </div>
      </form>
    </ng-container>
  </div>
</ng-template>

<ng-template #modalPasswordConfirm let-modal>
  <div class="modal-header">
    <h5 class="modal-title mt-0">Enviar reset de senha</h5>
    <button
      type="button"
      class="btn btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-hidden="true"
    ></button>
  </div>
  <div class="card align-items-center" *ngIf="circularProgressiveWait">
    <div card="card-body mt-n3">
      <div class="spinner-border text-primary m-1" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div>
      <button class="btn btn-sm btn-success" (click)="resetPassword()">
        Confirmar
      </button>
      <button class="btn btn-sm btn-danger" (click)="dialog.close()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>
